/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import BaseControl from 'scripts/base-control';
import can from 'can';
import localStorageService from 'scripts/services/localstorage-service';
import urlUtil from 'scripts/utils/url';
import FeedService from 'scripts/services/base-feed-service';
import domUtil from 'scripts/utils/dom';
import resultTemplate from './result.stache';
import answerTemplate from './answer.stache';
import dtm from 'scripts/services/dtm';

const pollFeedUrl = window.globalSettings.feeds.poll;

export const LivePoll = BaseControl.extend({
    init() {
        this._super();
        this.pollId = null
        this.resultsInterval = null;
        this.answersInterval = null;
        this.resultsElements = null;
        this.votedAnswer = null;
        this.pollPath = 'https://static.polldaddy.com/p/{pollId}.js';
        this.dataContainer = this.element.find('.s-live-poll-container');

        this.pollServiceFeed = new FeedService(pollFeedUrl, false, true)
            .on('data', (ev, data) => {
                if (data && data.pollId && data.pollId != this.pollId) {

                    let pollUrl = can.sub(this.pollPath, {pollId: data.pollId});
                    let scriptSrc = `${pollUrl}?t=${+new Date()}`;
                    let isVoted = this.userAlreadyVoted(data.pollId);

                    this.fillRequiredAttrs(data.pollId);
                    
                    domUtil.addScript(scriptSrc, () => {
                        let isClosed = this.pollIsClosed();
                        this.pollId = data.pollId;
                        this.setTitle();
                        if (isVoted && !isClosed) {
                            let viewResults = $('.m-live-poll .PDS_Poll .pds-vote a.pds-view-results');
                            this.generateMouseClickEvent(viewResults[0]);
                            this.fetchResults();
                        } else if (isClosed) {
                            this.fetchResults();
                        } else {
                            this.listenLocalStorageWriteEvent();
                            this.showAnswers();
                        }
                    });   
                }
            })
            .on('error', (error) => {
                console.error('Error fetching poll data', error);
            });

        this.pollServiceFeed.fetch();
    },

    localStorageChangeHandler: function(data) {
        let pollUrl = can.sub(this.pollPath, {pollId: this.pollId});
        let scriptSrc = `${pollUrl}?t=${+new Date()}`;
        let resultLocalStorageKey = can.sub('PD_poll_result_{pollId}', this.pollId);
        let votedItem = localStorageService.getItem(resultLocalStorageKey);

        if (votedItem) {
            this.votedAnswer = votedItem;
            $('.m-live-poll .PDS_Poll').html('');
            $('.m-live-poll .s-live-poll-container').html('');
        } else {
            return;
        }
        setTimeout(() => { // This timeout is required for polldaddy.
            domUtil.addScript(scriptSrc, () => {
                let viewResults = $('.m-live-poll .PDS_Poll .pds-vote a.pds-view-results');
                this.generateMouseClickEvent(viewResults[0]);
                this.fetchResults();
            });
        }, 3*1000);
    },  

    listenLocalStorageWriteEvent: function() {
        window.addEventListener('storage', this.localStorageChangeHandler.bind(this), false);
    },

    fillRequiredAttrs: function(pollId) {
        $('.m-live-poll .PDS_Poll').attr('id', `PDI_container${pollId}`);
    },

    fetchResults: function(){
        this.resultsInterval = setInterval(() => {
            this.resultsElements = $('.m-live-poll .PDS_Poll .pds-feedback-group');
            if (this.resultsElements && this.resultsElements.length){
                clearInterval(this.resultsInterval);
                this.showResults();
            }
        }, 500);
    },

    pollIsClosed: function() {
        let voteButton = $('.m-live-poll .PDS_Poll .pds-vote-button'),
            viewResults = $('.m-live-poll .PDS_Poll .pds-view-results');

        if(voteButton && voteButton.length && viewResults && viewResults.length) {
            return false;
        } else {
            return true;
        }
    },

    setTitle: function() {
        let title = $('.m-live-poll .pds-question .pds-question-top').text();
        $('.m-live-poll .s-live-poll-title').text(title);
    }, 

    showResults: function() {
        this.resultsCollection = [];
        this.resultsElements.each((key, value) => {
            let label = $(value).find('label.pds-feedback-label');
            
            let title = label.find('.pds-answer-text').text().trim(),
                resultInPercent = label.find('.pds-feedback-result .pds-feedback-per').text().trim();
            
            this.resultsCollection.push({ title: title, resultInPercent: resultInPercent });
        });

        this.renderResults();
    },

    renderResults: function() {
        this.dataContainer.html('');
        _.forEach(this.resultsCollection, (result) => {
            let selectedClass = (this.votedAnswer && this.votedAnswer.title == result.title) ? 'selected' : '';
            this.dataContainer.append(resultTemplate({ title: result.title, selectedClass: selectedClass, resultInPercent: result.resultInPercent }));
        });
    },
    
    showAnswers: function() {
        this.answersCollection = [];
        this.answersInterval = setInterval(() => {
            this.answersElements = $(`.m-live-poll #pds-answer${this.pollId} span.pds-answer-group`);
            if (this.answersElements && this.answersElements.length){
                clearInterval(this.answersInterval);
                this.answersElements.each((key, value) => {
                    let label = $(value).find('label');

                    let id = label.attr('for').replace('PDI_answer', ''),
                        title = label.find('.pds-answer-span').text();
                    if (title && id) {
                        this.answersCollection.push({title: title, id: id});
                    }
                });
                this.renderAnswers();
            }
        }, 500);
    },

    generateMouseClickEvent: function(element) {
        let evObj = document.createEvent('MouseEvents');
        evObj.initMouseEvent('click', true, true,null, null, 0, 0, 90, 90, false, false, false, false, 0, null );
        element.dispatchEvent(evObj);
    },

    renderAnswers: function() {
        this.dataContainer.html('');
        _.forEach(this.answersCollection, (answer) => {
            this.dataContainer.append(answerTemplate({ title: answer.title, id: answer.id }));
        });
    },

    userAlreadyVoted: function(pollId) {
        let pollKey = can.sub('PD_poll_result_{pollId}', pollId);
        let votedPoll = localStorageService.getItem(pollKey);
        
        if (votedPoll) {
            this.votedAnswer = votedPoll;
            return true;
        }
        return;
    },

    voteForAnswer: function(id, title) {
        let targetAnswerElement = $('.m-live-poll .PDS_Poll').find(can.sub('label[for="PDI_answer{id}"]', id));
        
        if(targetAnswerElement && targetAnswerElement.length) {
            this.votedAnswer = {id: id, title: title};
            localStorageService.setItem(can.sub('PD_poll_result_{pollId}', this.pollId), this.votedAnswer);
            this.generateMouseClickEvent(targetAnswerElement[0]);
            setTimeout(() => {
                let pollVoteButton = $('.m-live-poll .PDS_Poll .pds-vote a.pds-vote-button');
                this.generateMouseClickEvent(pollVoteButton[0]);
                this.fetchResults();
                dtm.trackPollSubmission();
            }, 100);
        }
    },
    '.s-live-poll-answer click': function(element, event) {
        let answerItem = $(event.currentTarget);
        if (answerItem.hasClass('disabled')) {
            return;
        }

        let answerId = answerItem.data('answer-id'),
            answerTitle = $(event.target).text().trim();

        if (answerId) {
            $(event.currentTarget).addClass('selected');
            this.element.find('.s-live-poll-answer').addClass('disabled');
            this.voteForAnswer(answerId, answerTitle);
        }
    },
    destroy() {
        if (this.pollServiceFeed) {
            this.pollServiceFeed.destroy();
            this.pollServiceFeed = null;
        }

        window.removeEventListener('storage', this.localStorageChangeHandler.bind(this));
    }

});
